import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    nodesTree: {},
    // currentIframeUrl: null
    userNodes: null,
    logout: false,
    appComponents: 0,
    appsLoggedOut: 0,
    unAuthorizedUser: false,
    style: null,
  },
  actions: {
    logoutAction(context) {
      context.commit("toggleLogout");
    },
    registerAppAction(context) {
      context.commit("incrementApps");
    },
    deregisterAppAction(context) {
      context.commit("decrementApps");
    },
    setUnAuthorizedUser(context) {
      context.commit("setUnAuthorizedUser");
    },
    notifyAppLogoutAction(context) {
      context.commit("incrementLoggedOutApps");
    },
    trackLogoutAction({ getters }) {
      let interval = 0;
      return new Promise(function(resolve, reject) {
        (function checkLogoutFeasibility() {
          if (getters.logoutCompleted) return resolve();
          interval += 100;
          if (interval < 5000) {
            setTimeout(checkLogoutFeasibility, 100);
          } else {
            //in case of timeout logout direct
            return resolve();
          }
        })();
      });
    },
  },
  getters: {
    logoutInitiated(state, getters) {
      return state.logout;
    },
    logoutCompleted(state, getters) {
      return state.appsLoggedOut >= state.appComponents;
    },
    userNodes(state, getters) {
      return state.userNodes;
    },
    style(state, getters) {
      return state.style;
    },
  },
  mutations: {
    setNodesTree(state, payload) {
      state.nodesTree = payload;
    },
    updateNodesTree() {
      //update the tree
    },
    updateUserNodes(state, payload) {
      state.userNodes = payload.userNodes;
    },
    toggleLogout(state) {
      state.logout = true;
    },
    incrementApps(state) {
      state.appComponents++;
    },
    decrementApps(state) {
      state.appComponents--;
    },
    incrementLoggedOutApps(state) {
      state.appsLoggedOut++;
    },
    setUnAuthorizedUser(state) {
      state.unAuthorizedUser = true;
    },
    setStyle(state, payload) {
      state.style = payload.style;
    },
    // updateCurrentFrameUrl(state, payload) {
    //   state.currentIframeUrl = payload.iframeUrl;
    // }
  },
});
